import { CircularProgress } from '@mui/material'
import styles from "./circularLoader.module.scss"

const CircularLoader: React.FC = () => {
  return (
    <div className={styles.wrapper}>
        <CircularProgress style={{ color: "#11643C",}} />
    </div>
  )
}

export default CircularLoader